class AttendanceSearchMapper {
  toPersistence(domainData) {
    return {
      idPaciente: domainData?.patientId,
      dataInicial: domainData?.initialDate,
      dataFinal: domainData?.endDate,
      statusAtendimento: domainData?.attendanceStatus,
      profissionalResponsavel: domainData?.responsibleProfessional,
      desfecho: domainData?.outcome,
      situacaoPagamento: domainData?.paymentSituation,
    }
  }
}

export default new AttendanceSearchMapper()
